import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import Core from '@hcm4all/frontend-core'

const { UploadCloud01 } = Core.UI.SVG.Icons
const { Download01, Trash01 } = Core.UI.SVG.Icons16

export default function FileUpload (props) {
  const {
    attachment,
    onFileChange,
    onRemoveAttachment,
    destroyAttachment,
    required = false,
    selectedFile = null
  } = props

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      onFileChange(acceptedFiles[0])
    }
  }, [onFileChange])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1
  })

  const showAttachment = attachment && !destroyAttachment
  const showSelectedFile = selectedFile && !showAttachment

  return (
    <div className='file-upload-container'>
      {showAttachment && (
        <div id='file-block'>
          <div className='fu-table__container mtop0'>
            <div className='fu-table__grid'>
              <div className='fu-table__header'>
                <div className='fu-table__header-cell'>
                  {attachment.filename}
                </div>
                <div className='fu-table__header-cell'>
                  <a
                    href={attachment.download_url}
                    className='fg-download-btn'
                  >
                    <Download01 />
                  </a>
                  <button
                    type='button'
                    className='fg-destroy-btn'
                    onClick={onRemoveAttachment}
                  >
                    <Trash01 />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSelectedFile && (
        <div className='form-group'>
          <label>
            {I18n.t('activerecord.attributes.calendar/event.file')}
            {required && <span className='text-danger'> *</span>}
          </label>
          <div className='fu-selected-file'>
            <span>{selectedFile.name}</span>
            <button
              type='button'
              className='fg-destroy-btn'
              onClick={() => onFileChange(null)}
            >
              <Trash01 />
            </button>
          </div>
        </div>
      )}

      <div
        className={`form-group ${showAttachment || showSelectedFile ? 'd-none' : ''}`}
      >
        <label>
          {I18n.t('activerecord.attributes.calendar/event.file')}
          {required && <span className='text-danger'> *</span>}
        </label>
        <div
          {...getRootProps()}
          className={`fu-container ${isDragActive ? 'drag-active' : ''} ${required ? 'fu-container--required' : ''}`}
        >
          <input {...getInputProps()} />
          <div className='fu-content'>
            <div><UploadCloud01 /></div>
            <div className='fu-text'>
              <span>{I18n.t('attachment_relations.uploading.upload_files')}</span>
              {' '}
              {I18n.t('attachment_relations.uploading.drag_files')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
